// Trilhas de jogos por nivel de suporte.
// Cada casa possui 7 partidas e agrupa jogos por habilidade.
// Os jogadores progridem sempre da casa 1 ate a 14.
const TRACK_SUPORTE_1 = [
  { casa: 1, habilidade: 'memória', jogos: ['genius', 'jogo da memória'], quantidades: [3, 4] },
  {
    casa: 2,
    habilidade: 'atenção',
    jogos: ['jogo da atenção', 'objetos secretos', 'figura certa'],
    quantidades: [2, 2, 3],
  },
  { casa: 3, habilidade: 'linguagem', jogos: ['jogo da forca', 'não é meu par'], quantidades: [3, 4] },
  {
    casa: 4,
    habilidade: 'raciocínio',
    jogos: ['desafio matemático', 'jogo das matrizes'],
    quantidades: [3, 4],
  },
  { casa: 5, habilidade: 'planejamento', jogos: ['jogo dos pontos'], quantidades: [7] },
  { casa: 6, habilidade: 'memória', jogos: ['genius', 'jogo da memória'], quantidades: [4, 3] },
  {
    casa: 7,
    habilidade: 'atenção',
    jogos: ['jogo da atenção', 'objetos secretos', 'figura certa'],
    quantidades: [3, 2, 2],
  },
  { casa: 8, habilidade: 'linguagem', jogos: ['jogo da forca', 'não é meu par'], quantidades: [4, 3] },
  {
    casa: 9,
    habilidade: 'raciocínio',
    jogos: ['desafio matemático', 'jogo das matrizes'],
    quantidades: [2, 5],
  },
  { casa: 10, habilidade: 'planejamento', jogos: ['jogo dos pontos'], quantidades: [7] },
  { casa: 11, habilidade: 'memória', jogos: ['genius', 'jogo da memória'], quantidades: [2, 5] },
  {
    casa: 12,
    habilidade: 'atenção',
    jogos: ['jogo da atenção', 'objetos secretos', 'figura certa'],
    quantidades: [2, 3, 2],
  },
  { casa: 13, habilidade: 'linguagem', jogos: ['jogo da forca', 'não é meu par'], quantidades: [3, 4] },
  {
    casa: 14,
    habilidade: 'raciocínio',
    jogos: ['desafio matemático', 'jogo das matrizes'],
    quantidades: [5, 2],
  },
];

// Os arquivos de Suporte 1 e Suporte 2 possuem a mesma distribuicao.
const TRACK_SUPORTE_3 = [
  { casa: 1, habilidade: 'categorização', jogos: ['quente ou frio', 'o que eu faço'], quantidades: [4, 3] },
  {
    casa: 2,
    habilidade: 'atenção',
    jogos: ['jogo da atenção', 'objetos secretos', 'figura certa', 'jogo das formas'],
    quantidades: [1, 2, 2, 2],
  },
  {
    casa: 3,
    habilidade: 'linguagem',
    jogos: ['jogo da forca', 'palavra intrusa', 'não é meu par'],
    quantidades: [2, 2, 3],
  },
  {
    casa: 4,
    habilidade: 'raciocínio',
    jogos: ['desafio matemático', 'jogo das matrizes'],
    quantidades: [3, 4],
  },
  { casa: 5, habilidade: 'categorização', jogos: ['quente ou frio', 'o que eu faço'], quantidades: [3, 4] },
  { casa: 6, habilidade: 'planejamento', jogos: ['jogo dos pontos'], quantidades: [7] },
  { casa: 7, habilidade: 'memória', jogos: ['jogo da memória'], quantidades: [7] },
  {
    casa: 8,
    habilidade: 'atenção',
    jogos: ['jogo da atenção', 'objetos secretos', 'figura certa', 'jogo das formas'],
    quantidades: [2, 1, 2, 2],
  },
  {
    casa: 9,
    habilidade: 'linguagem',
    jogos: ['jogo da forca', 'palavra intrusa', 'não é meu par'],
    quantidades: [3, 2, 2],
  },
  { casa: 10, habilidade: 'categorização', jogos: ['quente ou frio', 'o que eu faço'], quantidades: [4, 3] },
  {
    casa: 11,
    habilidade: 'raciocínio',
    jogos: ['desafio matemático', 'jogo das matrizes'],
    quantidades: [2, 5],
  },
  { casa: 12, habilidade: 'planejamento', jogos: ['jogo dos pontos'], quantidades: [7] },
  { casa: 13, habilidade: 'memória', jogos: ['jogo da memória'], quantidades: [7] },
  {
    casa: 14,
    habilidade: 'atenção',
    jogos: ['jogo da atenção', 'objetos secretos', 'figura certa', 'jogo das formas'],
    quantidades: [2, 2, 1, 2],
  },
];

export const SUPPORT_TRACKS = {
  'Suporte 1': TRACK_SUPORTE_1,
  'Suporte 2': TRACK_SUPORTE_1,
  'Suporte 3': TRACK_SUPORTE_3,
};

export const ABILITY_ORDER = [
  'categorização',
  'atenção',
  'linguagem',
  'raciocínio',
  'memória',
  'planejamento',
];

export const ABILITY_STYLES = {
  'memória': { color: '#8b5cf6', soft: '#ede9fe', text: '#5b21b6' },
  'atenção': { color: '#0ea5e9', soft: '#e0f2fe', text: '#075985' },
  'linguagem': { color: '#f59e0b', soft: '#fef3c7', text: '#92400e' },
  'raciocínio': { color: '#f43f5e', soft: '#ffe4e6', text: '#9f1239' },
  'planejamento': { color: '#10b981', soft: '#d1fae5', text: '#065f46' },
  'categorização': { color: '#14b8a6', soft: '#ccfbf1', text: '#115e59' },
};

export const getAbilityStyle = (ability) =>
  ABILITY_STYLES[ability] || { color: '#94a3b8', soft: '#f1f5f9', text: '#475569' };

export function buildPlayerProgress(partidas, level) {
  const track = SUPPORT_TRACKS[level] || SUPPORT_TRACKS['Suporte 3'];
  let remaining = Math.max(partidas || 0, 0);
  const abilityTotals = {};

  const houses = track.map((house) => {
    const total = house.quantidades.reduce((sum, quantity) => sum + quantity, 0);
    const played = Math.min(remaining, total);
    remaining -= played;

    let gameRemaining = played;
    const games = house.jogos.map((name, index) => {
      const planned = house.quantidades[index];
      const gamePlayed = Math.min(gameRemaining, planned);
      gameRemaining -= gamePlayed;
      return { name, planned, played: gamePlayed };
    });

    const status = played >= total ? 'completed' : played > 0 ? 'current' : 'pending';

    if (played > 0) {
      abilityTotals[house.habilidade] = (abilityTotals[house.habilidade] || 0) + played;
    }

    return { ...house, total, played, games, status };
  });

  const completedHouses = houses.filter((house) => house.status === 'completed').length;
  const currentHouse = houses.find((house) => house.status === 'current') || null;
  const nextHouse = houses.find((house) => house.status === 'pending') || null;
  const trackCompleted = completedHouses === houses.length;

  return {
    houses,
    abilityTotals,
    completedHouses,
    currentHouse,
    nextHouse,
    trackCompleted,
    totalPlanned: track.reduce(
      (sum, house) => sum + house.quantidades.reduce((houseSum, quantity) => houseSum + quantity, 0),
      0
    ),
  };
}
